import { ScopeState } from './state';
import { ScopeType } from './action';
import { Action } from '../action';

export const initialScopeState: ScopeState = {
    scopes: [],
};

const toggleScope = (previousScopes: string[], scope: string): string[] => {
    if (previousScopes.includes(scope)) {
        return previousScopes.filter(prev => prev !== scope);
    }

    return [...previousScopes, scope];
};

export const scopeReducer = (state: ScopeState | undefined, action: Action): ScopeState => {
    state = state ?? initialScopeState;

    switch (action.type) {
        case ScopeType.ScopeToggled:
            return { scopes: toggleScope(state.scopes, action.scope) };
        case ScopeType.ScopeReset:
            return initialScopeState;
        default:
            return state;
    }
};
